import { cn } from "@/lib/utils";

/** Tiny bar chart for a chapter's last-5-years question counts. */
export function TrendChart({
  values,
  className,
  showValues,
}: {
  values: number[];
  className?: string;
  showValues?: boolean;
}) {
  const points = values.filter((n) => Number.isFinite(n));
  if (!points.length) return null;
  const max = Math.max(...points, 1);
  const years = points.length;

  return (
    <div className={cn("flex items-end gap-1.5", className)} aria-hidden={!showValues}>
      {points.map((value, i) => (
        <div key={i} className="flex min-w-0 flex-1 flex-col items-center gap-1">
          {showValues ? (
            <span className="text-[10px] font-semibold tabular-nums text-muted-foreground">
              {value}
            </span>
          ) : null}
          <span
            className="w-full rounded-full bg-gradient-to-t from-blue-500 to-cyan-400"
            style={{ height: `${Math.max(8, (value / max) * 100)}%`, minHeight: 4 }}
          />
          {showValues ? (
            <span className="text-[9.5px] text-muted-foreground">Y{i + 1}</span>

          ) : null}
        </div>
      ))}
    </div>
  );
}
